import users from '../../api/users'
import i18n from '@/i18n'
// import { ZendeskLoginResponse } from '../../../dev_mock/ZendeskLoginResponse'

// initial state
const state = () => ({
  user: null,
  adminAccounts: null,
  userAccounts: null,
  isAdmin: false,
  signup: false,
  snackIsBlocked: false,
  showSpinner: false,
  language: {
    admin: null,
    agent: null
  },
  tooltipDelay: 300,
  userTodaySummaryReports: {},
  customerReportsFilters: {},
  exportData: {},
  graphData: {},
})

// getters
const getters = {
  // this is used to control if the user is loggedIn in Admin-PAnel
  loggedIn (state) {
    return !!state.user
  },
  // Retrieve data value to be used in the Dashboards
  getUserData (state) {
    return state.user
  },
  getAdminAccounts (state) {
    return state.adminAccounts
  },
  getUserAccounts (state) {
    return state.userAccounts
  },
  isUserAdmin (state) {
    return !!state.isAdmin
  },
  getCustomerWconfig (state){
    return (state.user 
      && Array.isArray(state.user.crmConfig) 
      && state.user.crmConfig.length
      && state.user.crmConfig[0].wconfig)
      ? state.user.crmConfig[0].wconfig
      : null
  },
  getCustomerCrmConfig (state){
    return state.user.crmConfig ? state.user.crmConfig : []
  },
  getCustomerFaasKeys (state){
    return state.user.faasKeys ? state.user.faasKeys : ""
  },
  getCustomerMessagingDataKeys (state){
    const platform = state.user.platform.toUpperCase();

    if (platform === 'LIVEPERSON') {
      return state.user.leMessagingDataKeys ? state.user.leMessagingDataKeys : {}
    } else if (platform === 'TWILIOFLEX') {
      return state.user.twilioflexDataKeys ? state.user.twilioflexDataKeys : {}
    }
  },
  getAdminData (state) {
    const adminProfile = {
      id: state.user.id,
      accountId: state.user.accountId,
      adminName: state.user.adminName,
      username: state.user.username,
      role: state.user.role,
      sessionId: state.user.sessionId
    }
    return adminProfile
  },
  getCustomerProfile (state){
    const customerProfile = {
      id: state.user.id,
      companyName: state.user.companyName,
      accountId: state.user.accountId,
      configId: state.user.configId,
      adminName: state.user.adminName,
      username: state.user.username,
      role: state.user.role,
      crmInstance: state.user.crmInstance,
      sessionId: JSON.parse(sessionStorage.getItem('user')).sessionId,
      platform: state.user.platform ? state.user.platform.toUpperCase() : 'LIVEPERSON'
    }

    return customerProfile
  },
  getCrmInstance(state) {
    return state.user.crmInstance ? state.user.crmInstance : ""
  },
  getSnackIsBlocked(state) {
    return state.snackIsBlocked
  },
  getShowSpinner(state) {
    return state.showSpinner
  },
  getLanguageAdmin(state) {
    return state.language.admin
  },
  getLanguageAgent(state) {
    return state.language.agent
  },
  getTooltipDelay(state) {
    return state.tooltipDelay
  },
  getUsertodaySummaryReports(state) {
    return state.userTodaySummaryReports
  },
  getCustomerReportsFilters(state) {
    return state.customerReportsFilters
  },
  getExportData(state) {
    return state.exportData
  },
  getGraphData(state) {
    return state.graphData
  },
}

// actions
const actions = {
  resetState: ({ commit }) => {
    commit('RESET_USER_STATE');
  },
  signup ({ commit }, signUpData) {
    return users.signUp(signUpData,
      (userData) => {
        // console.log(`userData ${JSON.stringify(userData)}`)
        commit('SIGNUP')
      },
      (error) => {
        console.error(`error ${JSON.stringify(error)}`);
        throw error;
      })
  },
  forgetPassword({ dispatch }, userData) {
    return users.forgetPassword(userData,
      (response) => {
        console.error(`user request for reset password success: ${JSON.stringify(response)}`);
      },
      (error) => {
        console.error(`user request for reset password error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  resetPassword({ dispatch }, userData) {
    return users.resetPassword(userData,
      (response) => {
        console.error(`Reset password success: ${JSON.stringify(response)}`);
      },
      (error) => {
        console.error(`Reset password error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  login({ dispatch }, credentials) {
    return users.login(credentials,
      (userData) => {
        dispatch('setUserData', userData)
      },
      (error) => {
        console.error(`user login error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  logout ({ commit }) {
    commit('RESET_USER_STATE');

    sessionStorage.removeItem('user')
    sessionStorage.removeItem('accessToken')

    location.reload()
  },
  setUserData ({ commit, dispatch }, userData) {
    // save the access Token on the sessionStorage
    const accessToken = userData.value.accessToken
    sessionStorage.setItem('accessToken', accessToken)

    // store the user's data in the sessionStorage
    sessionStorage.setItem('user', JSON.stringify(userData))

    // check if is admin or customer. If admin, set state.isAdmin as true
    const role = userData.role;

    if (role && role === 'customer') {
      commit('SET_USER_ISADMIN', false)
      
      // store the user's data in the store
      if (userData.value && userData.value.data) commit('SET_USER_DATA', userData.value.data);
      else commit('SET_USER_DATA', userData)

      // store the languages data in the store
      dispatch('setLanguageData', userData.value.data.language)
    } else if (role && role === 'admin') {
      // Admin locale should be always 'en'
      i18n.locale = 'en';
      
      commit('SET_USER_ISADMIN', true)
      
      // store the user's data in the store
      commit('SET_USER_DATA', userData)
    }

    // store the accounts's data in the store
    commit('SET_USER_ACCOUNTS', userData.value.data)
  },
  customerUpdateProfile({ commit }, updateProfileData) {
    return users.customerUpdateProfile(updateProfileData, 
      (updateResponse) => {
        console.log(`user customerUpdateProfile updateResponse: ${JSON.stringify(updateResponse)}`)
      },
      (error) => {
        console.error(`user customerUpdateProfile error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  customerUpdateMessagingKeys({ commit }, updateMessagingKeysData) {
    return users.customerUpdateMessagingKeys(updateMessagingKeysData, 
      (updateResponse) => {
        console.log(`user customerUpdateMessagingKeys updateResponse: ${JSON.stringify(updateResponse)}`)
      },
      (error) => {
        console.error(`user customerUpdateMessagingKeys error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  customerCreateNewUser({ commit }, createNewUserData) {
    return users.customerCreateNewUser(createNewUserData, 
      (updateResponse) => {
        console.log(`user customerCreateNewUser updateResponse: ${JSON.stringify(updateResponse)}`)
      },
      (error) => {
        console.error(`user customerCreateNewUser error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  customerUpdateCrmConfig({ commit }, updateCrmConfigData) {
    return users.customerUpdateCrmConfig(updateCrmConfigData, 
      (updateResponse) => {
        console.log(`user customerUpdateCrmConfig updateResponse: ${JSON.stringify(updateResponse)}`)
      },
      (error) => {
        console.error(`user customerUpdateCrmConfig error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  customerUpdateWconfig({ commit }, saveEntityData) {
    return users.customerUpdateWconfig(saveEntityData, 
      (updateResponse) => {
        console.log(`user customerUpdateWconfig updateResponse: ${JSON.stringify(updateResponse)}`)
      },
      (error) => {
        console.error(`user customerUpdateWconfig error: ${JSON.stringify(error)}`);
        throw error;
      })
  },
  setLanguageData({ commit }, payload) {
    // store the languages data in the store
    const fallbackLanguageObject = `[{"locale":"english","code":"en","app":"navomi-admin-panel-crmwidget-web"},{"locale":"english","code":"en","app":"navomi-agent-crmwidget-web"}]`
    
    if (payload && payload.length > 0 && typeof payload === 'string') payload = JSON.parse(payload)
    const languageObj = payload && payload.length > 0 ? payload : JSON.parse(fallbackLanguageObject)
    
    languageObj.forEach((lang) => {
      if (lang.app == "navomi-admin-panel-crmwidget-web"){
        commit('SET_LANGUAGE_ADMIN', lang)
        // update the I18N locale
        i18n.locale = lang.code;

        // update the sessionStorage I18N locale
        localStorage.setItem('locale-admin', lang.code)
      }
      else if (lang.app == "navomi-agent-crmwidget-web")
        commit('SET_LANGUAGE_AGENT', lang)
    })
  }
}

// mutations
const mutations = {
  RESET_USER_STATE(s) {
    const initial = state()
    Object.keys(initial).forEach(key => { s[key] = initial[key] })
    // Object.assign(state, getDefaultState())
  },
  SET_USER_DATA (state, userData) {
    state.user = { ...userData };
  },
  SIGNUP(state) {
    state.signup = true
  },
  SET_ADMIN_ACCOUNTS (state, payload) {
    state.adminAccounts = payload ? payload : null;
  },
  SET_USER_ACCOUNTS (state, payload) {
    state.userAccounts = payload ? payload : null;
  },
  SET_USER_ISADMIN (state, payload) {
    state.isAdmin = payload;
  },
  SET_USER_CONFIGITEMS(state, payload) {
    state.user.crmConfig = payload ? payload : null;
  },
  SET_USER_MESSAGINGDATAKEYS(state, payload) {
    const platform = state.user.platform.toUpperCase();
    
    if (platform === 'LIVEPERSON') {
      state.user.leMessagingDataKeys = payload ? payload : null;
    } else if (platform === 'TWILIOFLEX') {
      state.user.twilioflexDataKeys = payload ? payload : null;
    }
  },
  SET_SNACK_IS_BLOCKED(state, payload) {
    state.snackIsBlocked = payload
  },
  SET_SHOW_SPINNER(state, payload) {
    state.showSpinner = payload
  },
  SET_LANGUAGE_ADMIN(state, payload) {
    state.language.admin = payload
  },
  SET_LANGUAGE_AGENT(state, payload) {
    state.language.agent = payload
  },
  SET_USER_TODAY_SUMMARY_REPORTS(state, data) {
    state.userTodaySummaryReports = data;
  },
  SET_CUSTOMER_REPORTS_FILTERS(state, data) {
    state.customerReportsFilters = data;
  },
  SET_EXPORT_DATA(state, data) {
    state.exportData = data;
  },
  SET_GRAPH_DATA(state, data) {
    state.graphData = data;
  },
}

export default {
  namespaced: true,
  state: state(),
  getters,
  actions,
  mutations
}